/*
Purpose: list details of student with use datatable
Designed by R.Sanjai
Date:24/08/2023 
Project: TCMS


UpdateBy:KTH
updateDate:30/08/2023 
Purpose: include API
*/

import { useState, useCallback, useEffect, useMemo } from "react";
import { useNavigate, NavLink } from "react-router-dom";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import axios from 'axios';
import AddIcon from '@mui/icons-material/Add';

import Breadcrumbs from '@mui/material/Breadcrumbs';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import useColumnVisibilityState from "hooks/common/useLocalStorageState";

import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import LinearProgress from "@mui/material/LinearProgress";

import { security_key, BASE_URL } from "../global";



function ListTutor() {

  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [columnVisibilityModel, setColumnVisibilityModel] = useColumnVisibilityState("tutorTableColumnVisibility", {});

  const handleRowClick = async (e) => {
    navigate(`/edit-tutor`, { state: { pk_tut_key: `${e.pk_tut_key}` } });
  }

  const handleTimeSheetClick = async (e) => {
    navigate(`/ListTutorTimeSheet`, { state: { pk_tut_key: `${e.pk_tut_key}` } });
  }

  const [statusTarget, setStatusTarget] = useState(null);
  const [statusImpact, setStatusImpact] = useState(null);
  const [isStatusSubmitting, setIsStatusSubmitting] = useState(false);

  // Deactivating only blocks login and hides the tutor from assignment dropdowns; it never
  // unassigns existing work. Fetch what stays pointed at them so the modal can say so.
  const handleActiveToggle = async (row) => {
    const nextActive = parseInt(row.visibility) !== 1;
    setStatusTarget({ ...row, nextActive });
    setStatusImpact(null);

    if (!nextActive) {
      try {
        const response = await axios.post(BASE_URL + 'API/api_index.php', {
          security_key: security_key,
          mode: "getTutorDeactivationImpact",
          pk_tut_key: row.pk_tut_key,
          fk_cent_key: sessionStorage.getItem('key')
        });
        if (response.data.success === true) {
          setStatusImpact(response.data.data);
        }
      } catch (error) {
        console.error('Error fetching deactivation impact:', error);
      }
    }
  }

  const onConfirmStatusChange = async () => {
    setIsStatusSubmitting(true);
    try {
      const response = await axios.post(BASE_URL + 'API/api_index.php', {
        security_key: security_key,
        mode: "updateTutorActiveStatus",
        pk_tut_key: statusTarget.pk_tut_key,
        fk_cent_key: sessionStorage.getItem('key'),
        is_active: statusTarget.nextActive ? 1 : 0
      });

      if (response.data.success === true) {
        toast.success(statusTarget.nextActive ? "Tutor set to active" : "Tutor set to inactive", { autoClose: 700 });
        setStatusTarget(null);
        fetchData();
      } else {
        toast.error("Failure! Unable to update status. Try again later", { autoClose: 700 });
      }
    } catch (error) {
      console.error('Error updating tutor status:', error);
      toast.error("Failure! Unable to update status. Try again later", { autoClose: 700 });
    } finally {
      setIsStatusSubmitting(false);
    }
  }


  // Sample columns configuration
  const columns = [
    {
      headerName: 'Name',
      field: "Name",
      headerClassName: "super-app-theme--header",
      flex: 1,
      valueGetter: (params) => {
        return `${params.row.tut_fname == null || params.row.tut_fname == '' ? '-' : params.row.tut_fname + ' ' + params.row.tut_surname}`;
      },

    },
    {
      headerName: 'Phone',
      field: "Phone",
      headerClassName: "super-app-theme--header",
      flex: 1,
      valueGetter: (params) => {
        return `${params.row.tut_home_phone == null || params.row.tut_home_phone == '' ? '-' : params.row.tut_home_phone}`;
      },
    },
    {
      headerName: 'Assigned Sessions',
      field: "Sessions",
      headerClassName: "super-app-theme--header",
      flex: 1,
      valueGetter: (params) => {
        return `${params.row.count_session == null || params.row.count_session == '' ? '-' : params.row.count_session}`;
      },
    },
    {

      headerName: 'User Name',
      field: "User Name",
      headerClassName: "super-app-theme--header",
      flex: 1,
      valueGetter: (params) => {
        return `${params.row.ta_login_id == null || params.row.ta_login_id == '' ? '-' : params.row.ta_login_id}`;
      },
    },
    {

      field: "actions",
      type: "actions",
      headerName: "Active",
      headerClassName: "super-app-theme--header",
      width: 150,
      //flex: 1,
      disableExport: false,
      disableColumnFilter: false,
      disableColumnMenu: false,
      filterable: true,
      sortable: true,
      headerAlign: "left",
      valueGetter: (params) => {
        return `${parseInt(params.row.visibility) == 1 ? 'Active' : 'Inactive'}`;
      },
      renderCell: (params) => {
        const row = params.row;
        // Clickable status pill, matching the student list. The row is click-to-edit, so
        // stopPropagation keeps the click from bubbling into navigation.
        return parseInt(row.visibility) === 1 ? (
          <span
            className="active-btn my-auto cursor-pointer"
            onClick={(event) => { event.stopPropagation(); handleActiveToggle(row); }}
          >
            <DoneIcon className="icon-blue btn-icon me-1" />
            Active
          </span>
        ) : (
          <span
            className="deactive-btn my-auto cursor-pointer"
            onClick={(event) => { event.stopPropagation(); handleActiveToggle(row); }}
          >
            <CloseIcon className="btn-icon me-1" />
            Inactive
          </span>
        );
      }

    },
    {

      field: "TimeSheet",
      type: "actions",
      headerName: "Timesheet",
      headerClassName: "super-app-theme--header",
      width: 250,
      //flex: 1,
      headerAlign: "left",
      renderCell: (params) => {
        const row = params.row;
        return (<Button variant="outlined-red" className="primary-outlined" onClick={() => handleTimeSheetClick(row)} >Timesheet</Button>);
      }

    },
  ];

  // Sample data source

  //Api call start
  const [data1, setItems] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.post(BASE_URL + 'API/api_index.php', {
        security_key: security_key,
        mode: "getAllTutorByCenter",
        center_key: sessionStorage.getItem('key')
      });

      if (response.data.success === true) {
        setRecords(response.data.data);
        setItems(response.data.data);
        setLoading(false);

      } else {
        //alert message provide
        setLoading(false);

      }


    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  //Api call End


  const [records, setRecords] = useState([]);

  // Active/inactive is tbl_tutor_auth.visibility (1 = active). getAllTutorByCenter returns both,
  // so the tabs just filter client-side.
  const [tab, setTab] = useState("active");
  const activeCount = records.filter((r) => parseInt(r.visibility) === 1).length;
  const inactiveCount = records.length - activeCount;
  const filtered = useMemo(() => {
    return records.filter((r) =>
      tab === "active" ? parseInt(r.visibility) === 1 : parseInt(r.visibility) !== 1
    );
  }, [records, tab]);
  const hasActiveRows = filtered.length > 0;


  return (
    <div className="page-wrapper">

      {/* React alert */}
      <ToastContainer position="top-center" />

      <Modal show={statusTarget !== null} onHide={() => setStatusTarget(null)}>
        <Modal.Header>{statusTarget && statusTarget.nextActive ? 'Set Tutor Active' : 'Set Tutor Inactive'}</Modal.Header>
        <Modal.Body>
          {statusTarget && statusTarget.nextActive ? (
            <p>
              Are you sure? You want to set{" "}
              <b className="bg-warning">{statusTarget.tut_fname} {statusTarget.tut_surname}</b>{" "}
              back to active? They will be able to log in and can be assigned to sessions again.
            </p>
          ) : (
            <>
              <p>
                Are you sure? You want to set{" "}
                <b className="bg-warning">{statusTarget && `${statusTarget.tut_fname} ${statusTarget.tut_surname}`}</b>{" "}
                to inactive? They will no longer be able to log in, and will not be offered
                when assigning a tutor. Their existing sessions, timesheets and reports are kept.
              </p>

              {statusImpact && (parseInt(statusImpact.live_session_times) > 0 || parseInt(statusImpact.future_sessions) > 0) ? (
                <Card className="rounded-1 mt-2 card-bdr">
                  <Card.Body>
                    <h6>This tutor is still assigned to:</h6>
                    {parseInt(statusImpact.live_session_times) > 0 && (
                      <p className="ml-3 mb-2">{statusImpact.live_session_times} active session time(s)</p>
                    )}
                    {parseInt(statusImpact.future_sessions) > 0 && (
                      <p className="ml-3 mb-2">{statusImpact.future_sessions} upcoming session(s)</p>
                    )}
                    <p className="ml-3 mb-0">
                      These stay assigned to them. Reassign them to another tutor if they are no longer teaching.
                    </p>
                  </Card.Body>
                </Card>
              ) : null}
            </>
          )}
          <hr />
        </Modal.Body>
        <Modal.Footer className="pt-0">
          <div className="mx-auto d-flex gap-2">
            <Button
              variant="contained"
              className="primary-gray"
              onClick={() => setStatusTarget(null)}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className="primary-filled "
              disabled={isStatusSubmitting}
              onClick={() => onConfirmStatusChange()}
            >
              Yes
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* --------------Page Start--------------- */}


      {/* --------------Section Start--------------- */}

      <div className="mb-3 d-flex justify-content-between align-items-center">
        <div>
          <h5 className='page-title'> Tutors </h5>

          <div role="presentation" >
            <Breadcrumbs aria-label="breadcrumb" className='my-breadcrumbs'>
              <NavLink underline="hover" color="inherit" to='/calendar'> Home</NavLink>



              <Typography color="text.primary">Tutors</Typography>
            </Breadcrumbs>
          </div>
        </div>
        <div>
          <div className='d-flex align-items-center gap-2'>
            {/*<div>
                            <Button className="secondary-filled " variant="contained" onClick={() => navigate(window.history.back())}>
                                Back
                             </Button>
                         </div>*/}


            <NavLink className="primary-filled rounded-10 p-2" to='/add-tutor'>
              <AddIcon className="btn-icon" /> New Tutor</NavLink>

          </div>
        </div>
      </div>
      {/* Active / Inactive tabs */}
      <div className="mb-3">
        <div className="btn-group" role="group" aria-label="Tutor status tabs">
          <button
            type="button"
            className={`btn ${tab === "active" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => setTab("active")}
          >
            Active ({activeCount})
          </button>
          <button
            type="button"
            className={`btn ${tab === "inactive" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => setTab("inactive")}
          >
            Inactive ({inactiveCount})
          </button>
        </div>
      </div>

      <Card className='my-card p-1 bg-white'>

        <Card.Body>

          {/* -------------Content Start--------------- */}

          <Row>
            <Col xs="12">
              <div className="">

                <Row className="justify-content-center">





                  {/* --------------Table Content Start--------------- */}
                  <Col sm={12}>

                    <Box
                      sx={{
                        height: hasActiveRows ? "auto" : 200,
                        maxHeight: "calc(100vh - 270px)",
                        width: "100%",
                        "& .actions": {
                          color: "text.secondary",
                        },
                        "& .textPrimary": {
                          color: "text.primary",
                        },
                        "& .super-app-theme--header": {
                          backgroundColor: "#f4f4f4",
                        },
                      }}
                      style={{ width: "100%" }}
                    >
                      <DataGrid
                        sx={{
                          // disable cell selection style
                          '.MuiDataGrid-cell:focus': {
                            outline: 'none'
                          },
                          // pointer cursor on ALL rows
                          '& .MuiDataGrid-row:hover': {
                            cursor: 'pointer'
                          },
                          maxHeight: "calc(100vh - 270px)",
                        }}
                        //sx={{ border: "none", m: 2 }}
                        slots={{
                          loadingOverlay: LinearProgress,
                          //noRowsOverlay: CustomNoRowsOverlay,
                          toolbar: GridToolbar,
                          // toolbar: EditToolbar,
                        }}
                        slotProps={{
                          toolbar: {
                            csvOptions: { fileName: "TutorList" },
                            printOptions: {
                              pageStyle: `@media print {
                                      @page {
                                        size: A4 landscape;
                                        margin: 0;
                                      }
                                    }`, disableToolbarButton: true, hideFooter: true, hideToolbar: true, fileName: "TutorList"
                            },
                            records,
                            showQuickFilter: true
                          },


                        }}
                        showQuickFilter={true}

                        columnVisibilityModel={columnVisibilityModel}
                        onColumnVisibilityModelChange={setColumnVisibilityModel}

                        pagination={false}
                        hideFooterPagination
                        hideFooter
                        loading={loading}
                        rows={filtered.map((row, index) => ({ ...row, id: `row-${index}` }))}
                        columns={columns}
                        rowHeight={60} density="compact"
                        disableRowSelectionOnClick
                        showCellVerticalBorder={true}
                        showColumnVerticalBorder={true}
                        onRowClick={(params) => handleRowClick(params.row)}


                      />
                    </Box>



                  </Col>
                  {/* --------------Table Content Start--------------- */}

                </Row>

              </div>
            </Col>
          </Row>

          {/* --------------Content End--------------- */}


        </Card.Body>

      </Card>

      {/* --------------Section End--------------- */}




      {/* --------------Page End--------------- */}

    </div>
  );
}

export default ListTutor;